module.exports = __webpack_public_path__ + "img/my-pools-blue@2x.bdb02ede.png";